import React from 'react';
import PuzzleTooltip from '../../UI/tooltip/PuzzleTooltip';
import ColumnMenuWrapper from '../columnmenu/ColumnMenuWrapper';
import { HEADER_CELL_PROPS } from './Types';

class HeaderCell<P = {}, S = {}> extends React.PureComponent<HEADER_CELL_PROPS & P, S> {
  renderColumnMenu = () => {
    const { columnMenuWrapperProps, headerCellConfig } = this.props;

    return columnMenuWrapperProps.columnMenu && (
      <ColumnMenuWrapper
        {...columnMenuWrapperProps}
        popupClassName={headerCellConfig?.popupClassName}
      />
    );
  }

  renderInnerCell = () => {
    const {
      field,
      sortable,
      title,
      headerCellConfig
    } = this.props;
    const additionalClassName = headerCellConfig?.className ? headerCellConfig.className : '';

    return (
      <span
        className={`k-column-title ${sortable ? 'tp-pointable' : ''} ${additionalClassName}`}
        title={title}
      >
        {title || field || '\u00A0'}
      </span>
    );
  };

  render() {
    const {
      children,
      onClick,
      render,
      headerCellConfig,
      headerCellType,
      headerCustomContent,
      selectionValue
    } = this.props;

    const defaultRendering = (
      <PuzzleTooltip
        anchorElement="target"
        parentTitle={true}
        position={'bottom'}
      >
        <span className="k-cell-inner">
          {(headerCustomContent && headerCellConfig?.customContentReverse) ? headerCustomContent(selectionValue) : null}
          <span
            className="k-link"
            onClick={headerCellType === 'checkbox' ? undefined : onClick}
          >
            {this.renderInnerCell()}
            {children}
          </span>
          {this.renderColumnMenu()}
          {(headerCustomContent && !headerCellConfig?.customContentReverse) ? headerCustomContent(selectionValue) : null}
        </span>
      </PuzzleTooltip>
    );

    if (render) {
      return render.call(undefined, defaultRendering, this.props);
    }

    return defaultRendering;
  }
}

export default HeaderCell;
